'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import { useContext } from 'react';

import cx from 'clsx';

import carouselContext from 'components/ui/CarouselProvider/CarouselContext';
import Text from 'components/ui/Text';

import styles from './OverflowCarouselText.module.scss';

const OverflowCarouselText = ({ isInitialPaint }) => {
    const context = useContext(carouselContext);

    const lengths = context.slides?.map(
        slide =>
            slide.headline?.json?.content.reduce(
                (sum, line) => sum + (line.content?.[0]?.value?.length || 0),
                0
            ) || 0
    );
    const longestIndex = lengths?.indexOf(Math.max(...(lengths || [])));

    return context.slides?.map((slide, i) => {
        if (!slide.headline) return null;

        return (
            <div
                key={i}
                className={cx(styles.root, {
                    [styles.isActive]: context.activeIndex === i,
                    [styles.isPrev]: context.prevIndex === i,
                    [styles.isInitialPaint]: isInitialPaint,
                    [styles.isLongest]: i === longestIndex,
                })}
            >
                <div className={styles.textLockup}>
                    {slide.eyebrow && (
                        <div className={styles.eyebrowWrapper}>
                            <Text
                                className={styles.eyebrow}
                                baseTheme={'labelSmall'}
                                themes={{
                                    large: 'labelLarge',
                                }}
                                as="p"
                            >
                                {slide.eyebrow}
                            </Text>
                        </div>
                    )}
                    <div className={styles.headline}>
                        <div className={styles.headlineInner}>
                            {slide.headline?.json?.content.map((line, i) => {
                                if (line.content[0].value === '') {
                                    return null;
                                }
                                return (
                                    <Text
                                        key={i}
                                        className={styles.headlineLine}
                                        as="h2"
                                        baseTheme="displaySmall"
                                        themes={{
                                            xLarge: 'displayLarge',
                                        }}
                                    >
                                        {line.content[0].value}
                                    </Text>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    });
};

export default OverflowCarouselText;
